export const currencyFormat = (n, currency) => {
  if (currency)
    return currency + n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1 ');

  return n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1 ');
}

export const spacingFormat= (n) => {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}